import React, { useEffect, useState } from "react";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PrivacyPolicy = () => {
  const aboutUs = `${API_BASE_URL}/static/privacy-policy`;

  const [policyData, setpolicyData] = useState(null);

  const fetchData = async () => {
    try {
      const response = await fetch(aboutUs);
      const data = await response.json();
      setpolicyData(data?.data[0]);
      console.log(data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      {policyData ? (
        <div className="bg-white shadow-md rounded-lg p-6 max-w-5xl w-full text-justify">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-gray-800">
            {policyData?.heading}
          </h1>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mt-4 mb-2 text-gray-800">
            {policyData?.effective_date}
          </h2>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
            {policyData?.paragraph_1}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
            {policyData?.paragraph_2}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
            {policyData?.paragraph_3}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
            {policyData?.paragraph_4}
          </p>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mt-4 mb-2 text-gray-800">
          {policyData?.sub_heading_1}
          </h2>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {policyData?.paragraph_5}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {policyData?.paragraph_6}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {policyData?.paragraph_7}
          </p>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mt-4 mb-2 text-gray-800">
          {policyData?.sub_heading_2}
          </h2>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {policyData?.paragraph_8}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {policyData?.paragraph_9}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {policyData?.paragraph_10}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {policyData?.paragraph_11}
          </p>
        </div>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

export default PrivacyPolicy;
